import React from 'react';
import Svg from './Svg';
import Theme from '../../styles/theme';

const CloseIcon = (props) => {
	return (
		<Svg
			viewBox={'4 4 17 17'}
			color={props.color}
			containerStyle={props.style}
			onTouchTap={props.onTouchTap}
		>
			<path
				d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
			/>
		</Svg>
	);
};

CloseIcon.propTypes = {
	style: React.PropTypes.object,
	color: React.PropTypes.string,
	onTouchTap: React.PropTypes.func,
};

CloseIcon.defaultProps = {
	style: {},
	color: Theme.palette.primary2Color,
	onTouchTap: () => {},
};

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/images/CloseIcon.js